var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertWithdraw = function SvgAlertWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 11.3333V5.87367L6.35348 7.02016C6.15822 7.21542 5.84171 7.21542 5.64645 7.02016C5.45118 6.8249 5.45118 6.50839 5.64645 6.31313L7.64645 4.31313L7.68421 4.27862C7.88059 4.11842 8.17041 4.13006 8.35348 4.31313L10.3535 6.31313C10.5487 6.50839 10.5487 6.8249 10.3535 7.02016C10.1582 7.21542 9.84171 7.21542 9.64645 7.02016L8.49996 5.87367V11.3333C8.49996 11.6095 8.2761 11.8333 7.99996 11.8333C7.72382 11.8333 7.49996 11.6095 7.49996 11.3333Z",
    fill: "currentColor"
  })));
};
export default SvgAlertWithdraw;